import { TAG_CLOUD_WIDGET_SUCCESS } from './actions';

const tagCloudWidgetReducer = (state = {}, { type, payload }) => {
  switch (type) {
    case TAG_CLOUD_WIDGET_SUCCESS:
      return { ...state, ...payload };
    default:
      return state;
  }
};

export default tagCloudWidgetReducer;
